import { useEffect, useState } from "react";

import { Typography, Card } from "antd";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";

import './index.scss';

const { Title } = Typography;

interface InfoSectionProps {
  getCompaniesInfo(): any,
  isFetchingCompanyInfo: boolean,
};

const InfoSection = (props: InfoSectionProps) => {

  const [companyInfo, setCompanyInfo] = useState<any>({});

  useEffect(() => {
    props.getCompaniesInfo()
    .then((response: any[] ) => {
      setCompanyInfo(response.find((val: { RmiCompanyId: string | null; }) => val.RmiCompanyId === sessionStorage.getItem('ipaGroup')));
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });
  }, []);

  return (
    <Card className="row justify-content-center text-align-center" loading={props.isFetchingCompanyInfo}>
      <Title level={3}>{companyInfo?.RmiCompanyDisplayName}</Title>
      <b><p>{companyInfo?.RmiAddressLine1}<br />{companyInfo?.RmiAddressLine2}</p>

      <p>Telephone: {companyInfo?.RmiPhone}</p></b>
    </Card>
  );
};

export default InfoSection;